import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import buscarAdesaoPontoPorEmpresa from '../../actions/adesao-pontos/buscarAdesaoPontoPorEmpresa';
import { renderFieldCheck, renderFieldKM, renderFieldNumber } from '../../util/inputs';
import Titulo from '../comum/Titulo';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { renderField } from '../../util/arraysUtil';
import limparConfiguracaoPontoEmpresa from '../../actions/adesao-pontos/limparConfiguracaoPontoEmpresa';
import cadastrarConfiguracaoConsumoPontos from '../../actions/adesao-pontos/cadastrarConfiguracaoConsumoPontos';
import cadastrarConfiguracaoPonto from '../../actions/adesao-pontos/cadastrarConfiguracaoPonto';
import { showSuccessMsg } from '../../util/messagesUtil';
import { realParaNumber } from '../../util/numberUtil';

export class PainelCadastroConfiguracaoConsumoPonto extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }


    componentDidMount() {
        if (!this.props.empresaSelecionada.id) {
            this.props.history.push('/menu-adesao-pontos-empresa')
        }
        this.props.limparConfiguracaoPontoEmpresa();        
        this.props.buscarAdesaoPontoPorEmpresa(this.props.empresaSelecionada.id)
            .then(() => {
                this.carregarFormulario();
            })
    }

    componentDidUpdate(prevProps) {        
        if (alterouEmpresa(this.props, prevProps)) {            
            this.props.limparConfiguracaoPontoEmpresa();
            this.props.buscarAdesaoPontoPorEmpresa(this.props.empresaSelecionada.id)
                .then(() => {
                    this.carregarFormulario();
                })            
        }
    }

    carregarFormulario() {        
        if (this.props.adesaoPontoEmpresa.empresa) {
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'empresa', this.props.adesaoPontoEmpresa.empresa.nome);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'peso', this.props.adesaoPontoEmpresa.peso);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'ponto', this.props.adesaoPontoEmpresa.quantidadePonto);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'habilitadoGeracaoPontos', this.props.adesaoPontoEmpresa.habilitadoGeracaoPontos);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'habilitadoConsumoPontos', this.props.adesaoPontoEmpresa.habilitadoConsumoPontos);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'pontosReferencia', this.props.adesaoPontoEmpresa.quantidadePontosReferencia);
            this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos',
                'percentualEquivalente', this.props.adesaoPontoEmpresa.percentualEquivalente);
        }
    }

    naoEhPerfilAdmin() {
        return !validaPerfis([PERFIL_ADMIN])
    }

    montarParametros(values) {
        return {
            id: this.props.adesaoPontoEmpresa.id,
            empresaId: this.props.adesaoPontoEmpresa.empresa.id,
            peso: values.peso,
            ponto: values.ponto,
            habilitadoGeracaoPontos: values.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: values.habilitadoConsumoPontos,
            quantidadePontosReferencia: values.pontosReferencia,
            percentualEquivalente: values.percentualEquivalente
        }
    }

    montarParametrosConfiguracaoConsumoPontos(values) {
        return {
            id: this.props.adesaoPontoEmpresa.id,
            empresaId: this.props.adesaoPontoEmpresa.empresa.id,
            quantidadePontosReferencia: values.pontosReferencia,
            percentualEquivalente: values.percentualEquivalente
        }
    }

    submit(values) {        
        if (this.naoEhPerfilAdmin()) {
            this.props.cadastrarConfiguracaoConsumoPontos(this.montarParametrosConfiguracaoConsumoPontos(values), this.props.adesaoPontoEmpresa.empresa.id)
                .then(() => {                
                    showSuccessMsg('A configuração foi salva com sucesso!');                    
                });
            
        } else {
            this.props.cadastrarConfiguracaoPonto(this.montarParametros(values))
                .then(() => {                
                    showSuccessMsg('A configuração foi salva com sucesso!');                    
                });
        }
    }

    parserValor(valor) {
        if (isNaN(valor)) return 0;

        if (!valor) return 0;

        return valor.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
    }

    calcularPontos() {
        const valorPassagem = realParaNumber(this.props.valorPassagem);
        const quantidadePonto =  parseInt(this.props.adesaoPontoEmpresa.quantidadePonto) / realParaNumber(this.props.adesaoPontoEmpresa.peso);
        const pontosGanhos =  valorPassagem * quantidadePonto
        const percentualEquivalente = realParaNumber(this.props.percentualEquivalente);

        const pontosReferencia = +this.props.pontosReferencia;
        const percentualDesconto = (pontosGanhos * percentualEquivalente) / pontosReferencia

        
        return (
            <div className='col-12-col-sm-4 col-md-4'>
                <p style={{marginBottom: '0'}}><span>Valor da Passagem: </span> {!this.props.valorPassagem ? 0 : this.props.valorPassagem}</p>
                <p style={{marginBottom: '0'}}><span>Pontos: </span> {quantidadePonto}</p>
                <p style={{marginBottom: '0'}}><span>Pontos Ganhos: </span> {isNaN(pontosGanhos) ? 0 : pontosGanhos} </p>
                <p style={{marginBottom: '0'}}>Percentual de Desconto: {isNaN(percentualDesconto) ? 0 : percentualDesconto} % </p>
            </div>
        )
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <div>
                <div className='mt-2'>
                    <Titulo texto='Painel Cadastro Consumo de Pontos' urlRetorno="/menu-adesao-pontos-empresa" />
                    <div className='mb-2'>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>                            
                            <div className='form-row col-12'>
                                <div className="col-12 col-sm-4 col-md-4">
                                    <CampoSelecionarEmpresa />
                                </div>
                            </div>
                        </Autorizacao>
                    </div>
                    {this.props.adesaoPontoEmpresa.id ? <form onSubmit={handleSubmit(this.submit)}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Configurar Consumo de Pontos</legend>
                            <div className='form-row col-12'>
                                <div className="col-12 col-sm-4 col-md-4">                                    
                                    <div>
                                        <Field name="empresa" type="text" component={renderField}
                                            label="Empresa"
                                            css="form-control" readOnly={true} />
                                    </div>                                    
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                <div className='col-sm-9 col-md-2'>
                                    <Field name="peso" component={renderFieldKM} label="Peso:"
                                        css="form-control" readOnly={this.naoEhPerfilAdmin()} />
                                </div>
                                <div className='col-12-col-sm-4 col-md-2'>
                                    <Field name="ponto" type="text" component={renderFieldNumber}
                                        formatacao='#########'
                                        readOnly={this.naoEhPerfilAdmin()}
                                        label="Pontos:"
                                        css="form-control" />
                                </div>
                            </div>
                            <div className='form-row col-12 mt-3'>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <Field type="checkbox" name='habilitadoGeracaoPontos' component={renderFieldCheck}
                                        label="Ativar/Inativar para Geração de Pontos "
                                        css="form-check-input" readOnly={this.naoEhPerfilAdmin()}
                                    />
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <Field type="checkbox" name='habilitadoConsumoPontos' component={renderFieldCheck}
                                        label="Ativar/Inativar para Consumo de Pontos "
                                        css="form-check-input" readOnly={this.naoEhPerfilAdmin()}
                                    />
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                <div className='col-sm-9 col-md-2'>
                                    <Field name="pontosReferencia" component={renderFieldNumber} label="Pontos de Referência "
                                        css="form-control" readOnly={false} />
                                </div>
                                <div className='col-12-col-sm-4 col-md-2'>
                                    <Field name="percentualEquivalente" type="text" component={renderFieldKM}
                                        formatacao='#########'
                                        readOnly={false}
                                        label="Percentual Equivalente % "
                                        css="form-control" />
                                </div>
                            </div>                            
                        </fieldset>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Simulador de Pontos</legend>
                            <div className='form-row col-12 mb-2'>
                                <div className='col-12-col-sm-4 col-md-2'>
                                    <Field name="valorPassagem" type="text" component={renderFieldKM}
                                        formatacao='#########'
                                        readOnly={false}
                                        label="Valor da Passagem "
                                        css="form-control" />
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                {this.calcularPontos()}
                            </div>
                        </fieldset>
                        <div className=''>
                            <Link className="btn btn-laranja mr-2" to='/menu-adesao-pontos-empresa'>
                                Voltar
                            </Link>
                            <button type="submit"
                                disabled={invalid || submitting}
                                className="btn btn-laranja">Salvar
                            </button>
                        </div>
                    </form> : 'Não existe configuração de pontos para a empresa.'}
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {        
        empresaSelecionada: state.empresaSelecionada,
        adesaoPontoEmpresa: state.adesaoPontoEmpresa,
        pontosReferencia: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'pontosReferencia'),
        percentualEquivalente: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'percentualEquivalente'),
        valorPassagem: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'valorPassagem')
    }
}

export default withRouter(connect(mapStateToProps, {
    buscarAdesaoPontoPorEmpresa,    
    limparConfiguracaoPontoEmpresa,
    cadastrarConfiguracaoConsumoPontos,
    cadastrarConfiguracaoPonto,
    changeFieldValue
})(reduxForm({
    form: 'formularioCadastrarConfiguracaoConsumoPontos',
})(PainelCadastroConfiguracaoConsumoPonto)));